<div class="center-xy">
    @if (parameters.redirecting) {
        <div class="statistics__loading">
            <div class="statistics__loading__img">
                <loader></loader>
            </div>
        </div>
    }

    @if (subtitles.downloaded) {
        <div class="login-box bg-light">
            <img class="admin-logo"
                 ngSrc="/assets/img/top_menu/admin.svg"
                 width="50" height="50" priority="" alt=""/>
            <form>
                <input type="text"
                       class="login-box__text-input border-input color-basic font-16 font-regular"
                       name="username"
                       autocapitalize="none"
                       [(ngModel)]="authentication.username"
                       [placeholder]="(1132 | subtitle | lowercase)"
                       (keydown.enter)="authentication.login()"/>
                <input type="text"
                       class="login-box__text-input border-input color-basic font-16 font-regular"
                       name="adminName"
                       [(ngModel)]="authentication.adminName"
                       placeholder="admin"
                       (keydown.enter)="authentication.login()"/>
                <input type="password"
                       class="login-box__text-input border-input color-basic font-16 font-regular"
                       name="adminPassword"
                       [(ngModel)]="authentication.adminPassword"
                       [placeholder]="(1101 | subtitle | lowercase)"
                       (keydown.enter)="authentication.login()">
                <button type="button"
                        class="login-box__button bg-gradient color-light font-bold font-20 cursor-pointer"
                        (click)="authentication.login()">
                    {{ 1092 | subtitle }}
                </button>
            </form>
        </div>
    }
</div>
